import { Directive, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';
import { SortDirection, SortEvent } from './sort.types';

const rotate: Map<SortDirection, SortDirection> = new Map<SortDirection, SortDirection>([
  [SortDirection.none, SortDirection.Ascending],
  [SortDirection.Ascending, SortDirection.Descending],
  [SortDirection.Descending, SortDirection.none],
]);

@Directive({
  selector: 'th[appSortable]',
})
export class SortDirective implements OnInit {
  @Input() appSortable: string = '';
  @Input() direction: SortDirection = SortDirection.none;
  @Output() sort = new EventEmitter<SortEvent>();
  @Input() defaultSort: string = '';
  @Input() defaultDirection: string = '';
  @Input() noSortable: string = '';
  @Input() sortName: string = '';
  ngOnInit() {
    const { defaultSort, defaultDirection } = this;
    // this means defaultSort is true
    if (defaultSort === '') {
      if (defaultDirection === SortDirection.Ascending) {
        this.direction = SortDirection.Ascending;
        this.doRotate(true);
      }
      if (defaultDirection === SortDirection.Descending) {
        this.direction = SortDirection.Descending;
        this.doRotate(true);
      }
    }
  }

  @HostListener('click', ['$event'])
  rotate(event: { target: HTMLInputElement }) {
    if (event.target && event.target.nodeName === 'TH') {
      this.doRotate();
    }
  }

  doRotate(noRotate?: boolean) {
    if (this.noSortable === 'false') {
      if (!noRotate) {
        this.direction = rotate.get(this.direction) || SortDirection.none;
      }
      this.sort.emit({ column: this.appSortable, direction: this.direction });
    }
  }

  @HostBinding('class.asc')
  get isAsc() {
    return this.direction === SortDirection.Ascending;
  }

  @HostBinding('class.desc')
  get isDesc() {
    return this.direction === SortDirection.Descending;
  }
}
